// Dezenter Aufbauphase-Hinweis im Tæste-Stil
export default function LaunchNotice({ eyebrow, body, className = "", testId = "launch-notice" }) {
  return (
    <div
      data-testid={testId}
      className={`relative border border-[hsl(var(--brand-gold))]/40 bg-[hsl(var(--secondary))]/40 backdrop-blur-sm px-6 py-6 md:px-10 md:py-8 ${className}`}
    >
      <span
        aria-hidden="true"
        className="absolute left-0 top-6 bottom-6 w-[3px] bg-[hsl(var(--brand-gold))]"
      />
      <p className="eyebrow text-[hsl(var(--brand-gold))]">{eyebrow}</p>
      <div className="mt-3 space-y-3 text-base md:text-[17px] leading-relaxed text-[hsl(var(--foreground))]/85">
        {(Array.isArray(body) ? body : [body]).map((p, i) => (
          <p key={i}>{p}</p>
        ))}
      </div>
    </div>
  );
}
